import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import {
  ApiResDecrypt,
  onlyNumberLess100,
  onlyNumberSharing,
} from "../../CommonMethhods/CommonMethods";
import { AP_Master } from "../../Configuration/API_URL";
import axios from "axios";
import { toast } from "react-toastify";

function BrokerageTableApMaster(props) {
  let brokerageApi = props?.brokerageApi;
  let brokerageModules =
    brokerageApi?.modules !== undefined || null ? brokerageApi?.modules : "";
  const [middleModuleBrokerage, setMiddleModuleBrokerage] = useState(false);
  const [moduleName, setModuleName] = useState("")
  const [brokerageSlab, setBrokerageSlab] = useState([])
  const [ApSharing, setApSharing] = useState([])
  const [brokerage, setBrokerage] = useState()
  const [apSharingData, setApSharingData] = useState()
  const tableData=props.tableData
  const setTableData=props.setTableData
  const storeToken = localStorage.getItem("ssoToken");
  let mtfWiseSchema = Yup.object().shape({
    sharing: Yup.string().required(),
    mtfWiseSharing: Yup.string().required(),
    mtfWiseBaseRate: Yup.string().required(),
    lasWiseSharing: Yup.string().required(),
    lasWiseBaseRate: Yup.string().required(),
  });

  const mtfLasLongSchema = Yup.object().shape({
    sharing: Yup.string().required(),
    // baseRate: Yup.string().required(),
    brokerageFuture: Yup.string().required(),
    brokerageNifty: Yup.string().required(),
    brokerageBankNifty: Yup.string().required(),
    brokerageOptionStock: Yup.string().required(),
    mtfWiseSharing: Yup.string().notRequired(),
    mtfWiseBaseRate: Yup.string().notRequired(),
    lasWiseSharing: Yup.string().notRequired(),
    lasWiseBaseRate: Yup.string().notRequired(),
  });
  console.log("brokerage", brokerageModules, middleModuleBrokerage)
  const {
    formState: mtfLasState,
    register: mtfLasRegister,
    reset: mtfLasReset,
    getValues: mtfLasGet,
  } = useForm({
    resolver: yupResolver(mtfWiseSchema),
    mode: "onChange",
  });
  const {
    formState: mtfLasLongState,
    register: mtfLasLongRegister,
    reset: mtfLasLongReset,
    getValues: mtfLasLongGetValue,
  } = useForm({
    resolver: yupResolver(mtfLasLongSchema),
    mode: "onChange",
  });

  const updateCount = (data, i) => {
    console.log("data", data, i)
    if (i === 1) {
      setModuleName("")
      setBrokerage("")
      setApSharingData("")
      setMiddleModuleBrokerage(true);
      mtfLasLongReset();
      if (props?.updateData?.brokerage) {
        if (
          props?.updateData?.brokerage?.bid === 4 &&
          i === props?.updateData?.brokerage?.modules?.id - 1
        ) {
          mtfLasReset({
            sharing: props?.updateData?.brokerage?.modules?.sharing?.toString(),
            mtfWiseSharing:
              props?.updateData?.brokerage?.modules?.mtfSharing?.toString(),
            mtfWiseBaseRate:
              props?.updateData?.brokerage?.modules?.mtfBaseRate?.toString(),
            lasWiseSharing:
              props?.updateData?.brokerage?.modules?.lasSharing?.toString(),
            lasWiseBaseRate:
              props?.updateData?.brokerage?.modules?.lasBaseRate?.toString(),
          });
        } else {
          mtfLasReset({
            sharing: data?.sharing?.toString(),
            mtfWiseSharing: data?.mtfSharing?.toString(),
            mtfWiseBaseRate: data?.mtfBaseRate?.toString(),
            lasWiseSharing: data?.lasSharing?.toString(),
            lasWiseBaseRate: data?.lasBaseRate?.toString(),
          });
        }
      } else {
        mtfLasReset({
          sharing: data?.sharing?.toString(),
          mtfWiseSharing: data?.mtfSharing?.toString(),
          mtfWiseBaseRate: data?.mtfBaseRate?.toString(),
          lasWiseSharing: data?.lasSharing?.toString(),
          lasWiseBaseRate: data?.lasBaseRate?.toString(),
        });
      }
    }
    else if (i === 3) {
      setBrokerage("")
      setApSharingData("")
      setMiddleModuleBrokerage(false)
      setModuleName(data?.mname)
    }
    else {
      setBrokerage("")
      setApSharingData("")
      setModuleName("")
      setMiddleModuleBrokerage(false);
      mtfLasReset();
      if (props?.updateData?.brokerage) {
        if (
          props?.updateData?.brokerage?.bid === 4 &&
          i === props?.updateData?.brokerage?.modules?.id - 1
        ) {
          mtfLasLongReset({
            sharing: props?.updateData?.brokerage?.modules?.sharing?.toString(),
            // baseRate: props.updateData.brokerage.modules?.baseRate.toString(),
            brokerageTrade:
              props?.updateData?.brokerage?.modules?.trade?.toString(),
            brokerageDel:
              props?.updateData?.brokerage?.modules?.del?.toString(),
            brokerageFuture:
              props?.updateData?.brokerage?.modules?.future?.toString(),
            brokerageNifty:
              props?.updateData?.brokerage?.modules?.nifty?.toString(),
            brokerageBankNifty:
              props?.updateData?.brokerage?.modules?.bankNifty?.toString(),
            brokerageOptionStock:
              props?.updateData?.brokerage?.modules?.optionStock?.toString(),
            mtfWiseSharing:
              props?.updateData?.brokerage?.modules?.mtfSharing?.toString(),
            mtfWiseBaseRate:
              props?.updateData?.brokerage?.modules?.mtfBaseRate?.toString(),
            lasWiseSharing:
              props?.updateData?.brokerage?.modules?.lasSharing?.toString(),
            lasWiseBaseRate:
              props?.updateData?.brokerage?.modules?.lasBaseRate?.toString(),
          });
        } else {
          mtfLasLongReset({
            sharing: data?.sharing?.toString(),
            brokerageTrade: data?.trade?.toString(),
            brokerageDel: data?.del?.toString(),
            brokerageFuture: data?.future?.toString(),
            brokerageNifty: data?.nifty?.toString(),
            brokerageBankNifty: data?.bankNifty?.toString(),
            brokerageOptionStock: data?.optionStock?.toString(),
            mtfWiseSharing: data?.mtfSharing?.toString(),
            mtfWiseBaseRate: data?.mtfBaseRate?.toString(),
            lasWiseSharing: data?.lasSharing?.toString(),
            lasWiseBaseRate: data?.lasBaseRate?.toString(),
          });
        }
      } else {
        mtfLasLongReset({
          sharing: data?.sharing?.toString(),
          brokerageTrade: data?.trade?.toString(),
          brokerageDel: data?.del?.toString(),
          brokerageFuture: data?.future?.toString(),
          brokerageNifty: data?.nifty?.toString(),
          brokerageBankNifty: data?.bankNifty?.toString(),
          brokerageOptionStock: data?.optionStock?.toString(),
          mtfWiseSharing: data?.mtfSharing?.toString(),
          mtfWiseBaseRate: data?.mtfBaseRate?.toString(),
          lasWiseSharing: data?.lasSharing?.toString(),
          lasWiseBaseRate: data?.lasBaseRate?.toString(),
        });
      }
    }
  };
  const manageBrokerageData = () => {
    let AllModuleInput = document.querySelectorAll(".mtf-module");
    let CheckedArray = Array.from(AllModuleInput).filter(
      (item) => item.checked === true
    );
    let ModuleID = CheckedArray[0].value;
    if (ModuleID == "2") {
      if (mtfLasState.isValid) {
        return {
          ...mtfLasGet(),
          id: ModuleID,
        };
      }
    } 
    else if(ModuleID=="4"){
      return{
        "id": ModuleID,
        "sharing": 0,
        "trade": 0,
        "del": 0,
        "future": 0,
        "nifty": 0,
        "bankNifty": 0,
        "optionStock": 0
      }
    }
    else {
      if (mtfLasLongState.isValid) {
        return {
          ...mtfLasLongGetValue(),
          id: ModuleID,
        };
      }
    }
  };

  const manageBrokerage = () => {
    if (mtfLasLongState.isValid) {
      let AllModuleInput = document.querySelectorAll(".mtf-module");
      let CheckedArray = Array.from(AllModuleInput).filter(
        (item) => item.checked === true
      );
      let ModuleID = CheckedArray[0].value;
      return {
        ...mtfLasGet(),
        id: ModuleID,
      };
    }
  };

  props.biRef.manageBrokerage = manageBrokerage;
  props.biRef.manageBrokerageData = manageBrokerageData;

  const defaultShow = () => {
    let AllModuleInput = document.querySelectorAll(".mtf-module");

    if (props?.updateData.brokerage) {
      if (props?.updateData.brokerage?.bid === 4) {
        AllModuleInput[props.updateData.brokerage.modules.id - 1]?.click();
      } else {
        AllModuleInput[0]?.click();
      }
    } else {
      AllModuleInput[0]?.click();
    }
  };
  useEffect(() => {
    defaultShow();
  }, []);

  const getBrokerageSlab = async () => {

    try {
      const getModules = await axios.get(
        AP_Master.GetBrokerageSlab_URL,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getModules?.data);
      if (res?.status === 0) {
        console.log("res api brokerage slab", res?.data)
        setBrokerageSlab(res?.data)
      }
    } catch (error) {
      if (error?.request?.status === 401) {
        localStorage.clear("");

      }
      console.log(error);
    } finally {

    }
  };

  const getApSharingSlab = async () => {

    try {
      const getModules = await axios.get(
        AP_Master.GetApSharing_URL,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getModules?.data);
      if (res?.status === 0) {
        console.log("res api brokerage slab", res?.data)
        setApSharing(res?.data)
      }
    } catch (error) {
      if (error?.request?.status === 401) {
        localStorage.clear("");

      }
      console.log(error);
    } finally {

    }
  };
  useEffect(() => {
    if (moduleName === "Module 4") {
      getBrokerageSlab()
      getApSharingSlab()

    }
  }, [moduleName])
  const onChangeBrokerageSlab = (e) => {
    setBrokerage(e.target.value)
  }
  const onChangeApSharing = (e) => {
    setApSharingData(e.target.value)
  }
  const addToGrid = () => {
    if(brokerage && apSharingData){
    let data = {
      brokerage: brokerage,
      apSharing: apSharingData
    }
    console.log("data", data)
    if(tableData.length<=4){
    setTableData([...tableData,data])
    }
    else{
      toast.error("You can only add upto 5 points for an AP")
    }
  }
  else{

    toast.error("Please select Brokerage Slab and Ap Sharing Perc")
  }
  }
  console.log("tabledata", tableData)
  function onClickRemove(index){
    
      setTableData(tableData.filter((_, i) => i !== index));
 
  }
  return (
    <>
      <div className="module-main">
        {brokerageModules &&
          brokerageModules.map((item, key) => {
            return (
              <div className="radio-module" key={key}>
                <input
                  type="radio"
                  // id={item.id}
                  className="mtf-module"
                  name="mtf-module"
                  defaultValue={item.id}
                  // defaultChecked={key === mtfModuleCount ? true : false}
                  onClick={() => updateCount(item, key)}
                />

                <label>{item.mname}</label>
              </div>
            );
          })}
      </div>
      {middleModuleBrokerage ? (
        <form className="">
          <div className="ap_master_table scroll-table mtf-las-table width-for-sharing-only row">
            <table className="table width-table-small">
              <thead>
                <tr>
                  <th scope="col">Sharing</th>
                </tr>
              </thead>
              <tbody>
                <>
                  <tr>
                    <td>
                      <input
                        className="td-input"
                        id="mtf-input1"
                        autocomplete="off"
                        type="number"
                        onInput={(e) => {
                          onlyNumberSharing(e);
                        }}
                        {...mtfLasRegister(`sharing`)}
                      />
                    </td>
                  </tr>
                </>
              </tbody>
            </table>
            <table className="table col-8">
              <thead>
                <tr>
                  <th scope="col" colSpan={2}>
                    MTF
                  </th>
                </tr>
                <tr>
                  <th scope="col">Sharing</th>
                  <th scope="col">Base Rate</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input
                      className="td-input"
                      id="mtf-input1"
                      type="number"
                      maxLength={100}
                      autocomplete="off"
                      onInput={(e) => {
                        onlyNumberSharing(e);
                      }}
                      {...mtfLasRegister(`mtfWiseSharing`)}
                    />
                  </td>
                  <td>
                    <input
                      className="td-input"
                      id="mtf-input1"
                      type="number"
                      maxLength={100}
                      autocomplete="off"
                      onInput={(e) => {
                        onlyNumberSharing(e);
                      }}
                      {...mtfLasRegister(`mtfWiseBaseRate`)}
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <table className="table col-8">
              <thead>
                <tr>
                  <th scope="col" colSpan={2}>
                    LAS
                  </th>
                </tr>
                <tr>
                  <th scope="col">Sharing</th>
                  <th scope="col">Base Rate</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input
                      className="td-input"
                      id="mtf-input1"
                      type="number"
                      maxLength={100}
                      autocomplete="off"
                      onInput={(e) => {
                        onlyNumberSharing(e);
                      }}
                      {...mtfLasRegister(`lasWiseSharing`)}
                    />
                  </td>
                  <td>
                    <input
                      className="td-input"
                      id="mtf-input1"
                      type="number"
                      maxLength={100}
                      autocomplete="off"
                      onInput={(e) => {
                        onlyNumberSharing(e);
                      }}
                      {...mtfLasRegister(`lasWiseBaseRate`)}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <span className="field-error">
              {middleModuleBrokerage
                ? !mtfLasState.isValid && <>Field required *</>
                : !mtfLasLongState.isValid && <>Field required *</>}
            </span>
          </div>
        </form>
      ) :
        moduleName === "Module 4" ? (
          <div className="module4">
              <div className="row input-field-wrapper">
              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">Brokerage Slab:</label>
                  <select onChange={onChangeBrokerageSlab}>
                    <option value="">Select</option>
                    {brokerageSlab.length > 0 && brokerageSlab.map((item, index) => {
                      return (
                        <option key={index} value={item?.brokerageSlab}>{item?.brokerageSlab}</option>
                      )
                    })}

                  </select>
                </div>
                </div>
                <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">Ap Sharing Percent:</label>
                  <select onChange={onChangeApSharing}>
                    <option value="">Select</option>
                    {ApSharing.length > 0 && ApSharing.map((item, index) => {
                      return (
                        <option key={index} value={item?.perc}>{item?.perc}</option>
                      )
                    })}

                  </select>
                </div>
                </div>
               
            <button type="button"onClick={addToGrid}>Add to Grid</button>
              </div>
            
          { tableData.length>0 &&  <div className="ap_master_table scroll-table mtf-las-table row module4">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">
                      Sr. No.
                    </th>
                    <th scope="col">
                      Brokerage Slab
                    </th>
                    <th scope="col">
                      Ap Sharing Percent
                    </th>
                    <th scope="col">
                      Action
                    </th>
                  </tr>

                </thead>
                <tbody>
                  {tableData.length > 0 && tableData.map((item, index) => {
                    return (
                      <>
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            {item?.brokerage}
                          </td>
                          <td>{item?.apSharing}%</td>
                          <td style={{color:"rgba(246, 0, 0, 1)",cursor:"pointer"}} onClick={()=>onClickRemove(index)}>Remove</td>
                        </tr>
                      </>)
                  })}
                </tbody>
              </table>
            </div>}

          </div>
        ) :
          (
            <form className="">
              <div className="ap_master_table scroll-table mtf-las-table row">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Sharing</th>
                      {/* <th scope="col">Base Rate</th> */}
                      <th scope="col">Trade</th>
                      <th scope="col">Del</th>
                      <th scope="col">Future</th>
                      <th scope="col">Nifty</th>
                      <th scope="col">Bank Nifty</th>
                      <th scope="col">Option Stock</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          className="td-input"
                          id="mtf-input1"
                          autocomplete="off"
                          type="number"
                          onInput={(e) => {
                            onlyNumberSharing(e);
                          }}
                          {...mtfLasLongRegister(`sharing`)}
                        />
                      </td>
                      {/* <td>
                  <input
                    className="td-input"
                    id="mtf-input2"
                    type="number"
                    autocomplete="off"
                    onInput={(e) => {
                      onlyNumberLess100(e);
                    }}
                    {...mtfLasRegister(`baseRate`)}
                  />
                </td> */}
                      <td>
                        <input
                          className="td-input"
                          id="mtf-input3"
                          type="number"
                          autocomplete="off"
                          onInput={(e) => {
                            onlyNumberLess100(e);
                          }}
                          {...mtfLasLongRegister(`brokerageTrade`)}
                        />
                      </td>
                      <td>
                        <input
                          className="td-input"
                          id="mtf-input4"
                          type="number"
                          autocomplete="off"
                          onInput={(e) => {
                            onlyNumberLess100(e);
                          }}
                          {...mtfLasLongRegister(`brokerageDel`)}
                        />
                      </td>
                      <td>
                        <input
                          className="td-input"
                          id="mtf-input5"
                          type="number"
                          autocomplete="off"
                          onInput={(e) => {
                            onlyNumberLess100(e);
                          }}
                          {...mtfLasLongRegister(`brokerageFuture`)}
                        />
                      </td>
                      <td>
                        <input
                          className="td-input"
                          id="mtf-input6"
                          type="number"
                          autocomplete="off"
                          onInput={(e) => {
                            onlyNumberLess100(e);
                          }}
                          {...mtfLasLongRegister(`brokerageNifty`)}
                        />
                      </td>
                      <td>
                        <input
                          className="td-input"
                          id="mtf-input7"
                          type="number"
                          autocomplete="off"
                          onInput={(e) => {
                            onlyNumberLess100(e);
                          }}
                          {...mtfLasLongRegister(`brokerageBankNifty`)}
                        />
                      </td>
                      <td>
                        <input
                          className="td-input"
                          id="mtf-input8"
                          type="number"
                          autocomplete="off"
                          onInput={(e) => {
                            onlyNumberLess100(e);
                          }}
                          {...mtfLasLongRegister(`brokerageOptionStock`)}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table className="table col-8">
                  <thead>
                    <tr>
                      <th scope="col" colSpan={2}>
                        MTF
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">Sharing</th>
                      <th scope="col">Base Rate</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          className="td-input"
                          id="mtf-input1"
                          type="number"
                          maxLength={100}
                          autocomplete="off"
                          onInput={(e) => {
                            onlyNumberSharing(e);
                          }}
                          {...mtfLasLongRegister(`mtfWiseSharing`)}
                        />
                      </td>
                      <td>
                        <input
                          className="td-input"
                          id="mtf-input1"
                          type="number"
                          maxLength={100}
                          autocomplete="off"
                          onInput={(e) => {
                            onlyNumberSharing(e);
                          }}
                          {...mtfLasLongRegister(`mtfWiseBaseRate`)}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table className="table col-8">
                  <thead>
                    <tr>
                      <th scope="col" colSpan={2}>
                        LAS
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">Sharing</th>
                      <th scope="col">Base Rate</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          className="td-input"
                          id="mtf-input1"
                          type="number"
                          maxLength={100}
                          autocomplete="off"
                          onInput={(e) => {
                            onlyNumberSharing(e);
                          }}
                          {...mtfLasLongRegister(`lasWiseSharing`)}
                        />
                      </td>
                      <td>
                        <input
                          className="td-input"
                          id="mtf-input1"
                          type="number"
                          maxLength={100}
                          autocomplete="off"
                          onInput={(e) => {
                            onlyNumberSharing(e);
                          }}
                          {...mtfLasLongRegister(`lasWiseBaseRate`)}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <span className="field-error">
                  {middleModuleBrokerage
                    ? !mtfLasState.isValid && <>Field required *</>
                    : !mtfLasLongState.isValid && <>Field required *</>}
                </span>
              </div>
            </form>
          )}
    </>
  );
}

export default BrokerageTableApMaster;
